import { gql } from '@apollo/client/core'

const MESSAGE_FIELDS = 'id role content attachments { url name description } toolCalls { name label ok } inputTokens outputTokens costUsd latencyMs createdAt'

export const AI_ASSISTANT_MODEL_QUERY = gql`query AiAssistantModel { aiAssistantModel }`

export const AI_CONVERSATIONS_QUERY = gql`
  query AiConversations { aiConversations { id title createdAt updatedAt messageCount lastMessageAt } }
`

export const AI_MESSAGES_QUERY = gql`
  query AiMessages($conversationId: Int!) { aiMessages(conversationId: $conversationId) { ${MESSAGE_FIELDS} } }
`

export const CREATE_AI_CONVERSATION = gql`mutation CreateAiConversation { createAiConversation { id title } }`

export const DELETE_AI_CONVERSATION = gql`mutation DeleteAiConversation($id: Int!) { deleteAiConversation(id: $id) }`

export const SEND_AI_MESSAGE = gql`
  mutation SendAiMessage($conversationId: Int, $content: String!, $attachments: [String!]) {
    sendAiMessage(conversationId: $conversationId, content: $content, attachments: $attachments) {
      ok error
      userMessage { ${MESSAGE_FIELDS} }
      assistantMessage { ${MESSAGE_FIELDS} }
    }
  }
`;
